import { render, staticRenderFns } from "./expiredPolicy.vue?vue&type=template&id=43bc172b&scoped=true"
import script from "./expiredPolicy.vue?vue&type=script&lang=js"
export * from "./expiredPolicy.vue?vue&type=script&lang=js"
import style0 from "./expiredPolicy.vue?vue&type=style&index=0&id=43bc172b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc172b",
  null
  
)

export default component.exports